// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"d1491329","241":"781153d9","374":"43851ba5","393":"71e90084","453":"666c8ae1","654":"1ca3c3fd","722":"8d0d4f07","772":"4f54a748","852":"46cd7ced","891":"64c97f0b","966":"762a9b72"}[chunkId] + ".chunk.js";
};